jQuery(document).ready(function($){
  
  $(window).scroll(function() {    

      var scroll = $(window).scrollTop();

      if (scroll >= 10) {
          $(".x-navbar").addClass("sticky");
      } else {
          $(".x-navbar").removeClass("sticky");
      }
    
  });
  
});